import { gql } from "@apollo/client";
import type { AllStockTakeLotFieldsFragment as StockTakeLot } from "./__generated__/stock-take-lots-fragment.gql";
import type { StockTakeSummaryRow } from "./stock-take-summary-table";

/**
 * In order for the Apollo client to be able to deserialise your response, you must
 * declare fragments of unions in the `possibleTypes` key of the InMemoryCache when
 * the client is instantiated.
 * https://www.apollographql.com/docs/react/data/fragments/#using-fragments-with-unions-and-interfaces
 *
 * If you add further unions, they must be added there:
 * src/client/apollo/client.js
 */
export const AllStockTakeLotFieldsFragment = gql`
  fragment AllStockTakeLotFields on StockTakeLot {
    ... on StockTakeLotUpdate {
      id
      name
      lot {
        expiryDate
        sku {
          id
          externalReferences {
            origin
          }
        }
      }
      reviewedQuantity
      initialQuantity
      quantityDifference
      lastStockTakeAt
    }
    ... on StockTakeLotAddition {
      id
      name
      expiryDate
      additionReviewQuantity: reviewedQuantity
      additionQuantityDifference: quantityDifference
      lastStockTakeAt
      additionLot: lot {
        sku {
          id
          externalReferences {
            origin
          }
        }
      }
    }
  }
`;

export function mapStockTakeLotsFragmentToRows(
  items: readonly StockTakeLot[],
): StockTakeSummaryRow[] {
  return items.map((item) => {
    if (item.__typename === "StockTakeLotAddition") {
      return {
        id: item.id,
        name: item.name,
        expiryDate: item.expiryDate,
        initialQuantity: 0,
        reviewedQuantity: item.additionReviewQuantity,
        quantityDifference: item.additionQuantityDifference,
        lastStockTakeAt: item.lastStockTakeAt,
        externalReferences: item.additionLot?.sku?.externalReferences,
      };
    }

    return {
      id: item.id,
      name: item.name,

      expiryDate: item.lot?.expiryDate,

      initialQuantity: item.initialQuantity,

      reviewedQuantity: item.reviewedQuantity,

      quantityDifference: item.quantityDifference,
      lastStockTakeAt: item.lastStockTakeAt,
      externalReferences: item.lot?.sku?.externalReferences,
    };
  });
}
